if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        try {
          if (this.minicart) {
            formData.append(
              "sections",
              this.minicart.getSectionsToRender().map((section) => section.section),
            );
          }
          formData.append("sections_url", getPageUrlWithMarket());
          config.body = formData;

          const response = await fetch(`${appendMarketParams(routes.cart_add_url)}`, config);
          const result = await response.json();

          if (result.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: result.errors || result.description,
              message: result.message,
            });

            this.handleErrorMessage(result.description);
            if (this.minicart) {
              this.minicart.updateSectionContents();
            }
            return;
          }

          if (this.minicart) {
            this.minicart.renderContents(result);
          }

          if (window.themeSettings.redirectToCart) {
            location.href = window.routes.cart_url;
          } else if (this.minicart) {
            if (this.quickViewDrawer) {
              this.quickViewDrawer.close();
              document.body.classList.add("drawer-open");
              setTimeout(() => this.minicart.open(), 200);
            } else {
              this.minicart.open(submitButton);
            }
          }

          const addEvent = new CustomEvent("cart:item-add", {
            detail: {
              items: [result],
              context: this.eventContext,
            },
          });
          document.dispatchEvent(addEvent);

          publish(PUB_SUB_EVENTS.cartItemAdd, {
            source: this.eventContext,
            items: [result],
          });
        } catch (error) {
          console.error(error);
        } finally {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          this.querySelector(".button-overlay-spinner").classList.add("hidden");
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
